module.exports = __webpack_public_path__ + "static/media/1.d61c0052.jpg";